<script setup lang="ts">
import type { PortableTextComponentProps } from "@portabletext/vue";

const props = defineProps<
  PortableTextComponentProps<{
    _key: string;
    _type: string;
    dataType?: string;
    text: string | { _type: 'reference'; _ref: string; _weak?: boolean } | undefined;
  }>
>();

// The GROQ query should resolve text to a string, but handle both formats for safety
const displayText = computed(() => {
  const textValue = props?.value?.text;
  if (!textValue) return '';
  if (typeof textValue === 'string') return textValue;
  // If it's still a reference object (shouldn't happen after GROQ resolution), return empty
  return '';
});
</script>

<template>
  <span>{{ displayText }}</span>
</template>

